import axiosClient from './axios';

const tokenAdminAuth = (token: string) : void => {
  if(token)
    axiosClient.defaults.headers.common["token-admin"] = token
  else
    delete axiosClient.defaults.headers.common["token-admin"]
}

export default tokenAdminAuth